<template lang="pug">
div
  .canvas(ref='canvas')
    div(v-if='object.mobile_genplan_url')
      img(:src='object.mobile_genplan_url', ref='genplan')
      interact(
        draggable,
        v-for='(point, index) in points',
        :key='index',
        :dragOption='options',
        :style='getStyle(index)',
        @dragmove='dragmove(index, $event)'
      )
        .marker(:data-id='`mp-marker-${index}`')
          .marker-inner
            v-tooltip(:top='true', :attach='`[data-id=mp-marker-${index}]`')
              img(src='/marker.svg', slot='activator')
              div {{ point.name }}
    div(v-else)
      .upload Сначала загрузите генплан
  v-container(grid-list-xl, fluid)
    v-flex(xs12, sm4)
      s-image-upload(
        :src='object.mobile_genplan_url',
        @remove-success='removeGenplanImage',
        v-model='object.mobile_genplan',
        label='Генплан МП'
      )
  v-card-actions.large
    v-spacer
    s-back-btn
    v-btn(:loading='loading', @click.native='save', color='primary', depressed) Сохранить
</template>

<script>
import http from '@/http'
import interact from 'interactjs'
import { omit } from 'lodash'
import { createFormData } from '@/utils'

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
  },

  data: function () {
    return {
      w: 40,
      h: 40,
      loading: false,
      points: [],
      object: {},
      options: {
        modifiers: [
          interact.modifiers.restrictRect({
            restriction: 'parent',
            endOnly: true,
            elementRect: {
              left: -0.5,
              right: 0.5,
              top: -1,
              bottom: 0,
            },
          }),
        ],
      },
    }
  },

  mounted() {
    this.fetch()
  },

  methods: {
    fetch() {
      this.loading = true
      Promise.all([this.fetchPoints(), this.fetchObject()]).then(
        () => (this.loading = false)
      )
    },

    save() {
      this.loading = true
      Promise.all([this.saveObject(), this.savePoints()])
        .then(() => (this.loading = false))
        .then(() => this.fetch())
    },

    removeGenplanImage() {
      this.object.mobile_genplan = null
      this.object.mobile_genplan_url = null
    },

    async fetchObject() {
      try {
        const res = await http.get(`/complexes/${this.id}`)
        this.object = res.data
      } catch (error) {
        this.$root.showSnack('Ошибка загрузки комплекса')
      }
    },

    async fetchPoints() {
      try {
        const res = await http.get(`/complexes/${this.id}/mobilepoints`)
        this.points = parsePoint(res.data)
      } catch (error) {
        this.$root.showSnack('Ошибка загрузки генплана МП')
      }
    },

    async saveObject() {
      try {
        const data = createFormData(this.object)
        await http.post(`/complexes/${this.id}`, data)
      } catch (error) {
        this.$root.showSnack('Ошибка сохранения комплекса')
      }
    },

    async savePoints() {
      const points = this.points
        .map((point) => ({
          ...point,
          mobile_genplan_position: {
            top: point.top,
            left: point.left,
          },
        }))
        .map((point) => omit(point, ['top', 'left']))

      try {
        // prettier-ignore
        await http.patch(`/complexes/${this.id}/mobilepoints`, { objects: points })
        this.$root.showSnack('Генплан сохранен')
      } catch (error) {
        this.$root.showSnack('Ошибка сохранения генплана МП')
      }
    },

    dragmove(index, event) {
      const point = this.points[index]
      if (point) {
        const { width, height } = this.$refs.canvas.getBoundingClientRect()
        point.left = point.left + (event.dx * 100) / width
        point.top = point.top + (event.dy * 100) / height
        this.points[index] = point
      }
    },

    getStyle(index) {
      const point = this.points[index]
      return {
        height: `${this.h}px`,
        width: `${this.w}px`,
        position: 'absolute',
        left: point.left + '%',
        top: point.top + '%',
      }
    },
  },
}

const parsePoint = (points) => {
  let count = 1

  const top = 10
  const step = 3.5
  const results = []

  for (const point of points) {
    if (null === point.mobile_genplan_position) {
      point.top = top
      point.left = count * step
      count++
    } else {
      point.top = point.mobile_genplan_position.top
      point.left = point.mobile_genplan_position.left
    }
    results.push(point)
  }
  return results
}
</script>

<style scoped>
.canvas {
  position: relative;
}
.canvas img {
  width: 100%;
  height: 100%;
  display: block;
}
.marker {
  width: 40px;
  height: 40px;
  position: absolute;
  top: -40px;
  left: -20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.marker .v-tooltip__content {
  top: 5px !important;
  left: 45px !important;
  white-space: nowrap;
}
.icon {
  color: white;
  display: block;
  font-size: 48px;
}
.upload {
  padding: 24px;
  text-align: left;
}
</style>
